import { FlatTitledSitecoreItem } from '../models';

/**
 * Retrieves a display title from a Sitecore item.
 * Prefers the localized `Title` field, then falls back to `TitleDictionary.Phrase`.
 *
 * @param item - The Sitecore item with optional Title / TitleDictionary fields.
 * @returns The resolved title string, or undefined if neither field is filled in.
 */
export const getTitle = <T>(item: FlatTitledSitecoreItem<T>): string | undefined => {
  const itemTitle = item?.Title;
  const itemTitleDictionary = item?.TitleDictionary?.Phrase;

  if (itemTitle?.value) {
    return itemTitle.value as string;
  }

  if (!itemTitleDictionary) {
    return undefined;
  }

  return itemTitleDictionary.value;
};
